import { apiInstance } from '@diamond/shared/utils';

export const deleteRecipe = async (token: string, recipeId: string) => {
  const url = `/backoffice/recipe/${recipeId}`;
  return apiInstance(token).delete(url);
};
